import { render } from "./ChartAxisLabel.vue?vue&type=template&id=7baf3067&scoped=true"
import script from "./ChartAxisLabel.vue?vue&type=script&lang=js"
export * from "./ChartAxisLabel.vue?vue&type=script&lang=js"

import "./ChartAxisLabel.vue?vue&type=style&index=0&id=7baf3067&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7baf3067"]])

export default __exports__